"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Legierung = void 0;
var Legierung;
(function (Legierung) {
    Legierung["ag925"] = "ag925";
    Legierung["au333"] = "au333";
    Legierung["au375"] = "au375";
    Legierung["au585"] = "au585";
    Legierung["au750"] = "au750";
    Legierung["pt600"] = "pt600";
    Legierung["pt950"] = "pt950";
    Legierung["pd585"] = "pd585";
    Legierung["pd950"] = "pd950";
})(Legierung = exports.Legierung || (exports.Legierung = {}));
//# sourceMappingURL=Legierung.js.map